/** Observe the target and ancestors so sibling/layout changes trigger remeasurement. */
export const observeGuideTourTargetLayoutRoots = (
  resizeObserver: ResizeObserver,
  element: HTMLElement
): void => {
  let node: HTMLElement | null = element

  while (node) {
    resizeObserver.observe(node)
    node = node.parentElement
  }

  resizeObserver.observe(document.documentElement)
}
